// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { ClearProducts, SetProducts } from '@actions/products';

interface Product {
  _id: string;
  [key: string]: unknown;
}

interface ProductsState {
  products: Product[];
  hasNext: boolean;
  isLoading: boolean;
}

interface SetProductsPayload {
  products?: Product[];
  hasNext?: boolean;
  isLoading?: boolean;
}

type SetProductsAction = Action<SetProductsPayload>;

const initialState: ProductsState = {
  products: [],
  hasNext: true,
  isLoading: false,
};

export default handleActions<ProductsState, SetProductsPayload | void>(
  {
    [SetProducts.toString()]: (
      state: ProductsState,
      { payload }: SetProductsAction,
    ): ProductsState => {
      return {
        ...state,
        ...payload,
        products: [
          ...state.products,
          ...(payload?.products ? payload.products : []),
        ],
      };
    },
    [ClearProducts.toString()]: (): ProductsState => {
      return initialState;
    },
  },
  initialState,
);
